<template>
  <div>
    <WechatCategoryDialog
      v-if="renderDialog"
      v-model="dialogVisible"
      :categories="value"
      :options="categories"
      @success="handleAdd"
    />
    <el-form>
      <el-form-item v-for="(item, index) in value" :key="index">
        <div style="display:flex; align-items: center">
          {{ getCategoryName(item) }}
          <el-button icon="el-icon-delete" circle style="margin-left: 10px;" @click="handleDelete(index)"></el-button>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-plus" @click="dialogVisible = true">添加类目</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { Vue, Component, Model, Emit } from 'vue-property-decorator';
  import _ from 'lodash';
  import WechatCategoryDialog from './wechat-category-dialog';

  @Component({
    components: {
      WechatCategoryDialog
    }
  })
  export default class WechatCategory extends Vue {
    @Model('change', { type: Array, default: () => [] }) value;
    categories = [];
    dialogVisible = false;
    renderDialog = true;

    async mounted() {
      this.categories = await this.$request.get('/wechat_third_party_platform/wechat_categories/available');
    }

    getCategoryName(item) {
      const { first, second } = item;
      const firstName = _.get(this.categories.find(item => item.id === first), 'name');
      const secondName = _.get(this.categories.find(item => item.id === second), 'name');
      return `${firstName}/${secondName}`;
    }

    @Emit('change')
    handleAdd(data) {
      const value = _.cloneDeep(this.value);
      value.push(data);
      this.dialogVisible = false;

      // 销毁弹窗
      this.$nextTick(() => {
         this.renderDialog = false;
        this.$nextTick(() => this.renderDialog = true);
      });
      return value;
    }

    @Emit('change')
    handleDelete(index) {
      const value = _.cloneDeep(this.value);
      value.splice(index, 1);
      return value;
    }
  }
</script>

<style>

</style>
